import {
  surrounding,
  differentialSettlement,
  basics,
  firstFloorSlope,
  wall,
  corrosionOrTermite,
  settlementSlope,
  slope,
  buckling,
  brace,
  pillarBeamJoint,
  pillarBase,
  corrosion,
  partsDamageGte3,
  groundDestructionSettlement,
  pillarDamage5,
  pillarDamage4,
  mostDamagedFloor,
  settlementSlopeSteel
} from '@/constants/ui/inspection/step2/step2Card/neighboringCards'
import { CONSTRUCTION_TYPE } from '@/constants/accessor/api/emergencyInspectionResult/assessmentInfo/constructionType'
import type { ConstructionTypeType } from '@/types/ui/inspection/constructionTypeTypes'

const WOOD = [
  surrounding,
  differentialSettlement,
  basics,
  firstFloorSlope,
  wall,
  corrosionOrTermite
]

const STEEL = [
  surrounding,
  settlementSlopeSteel,
  slope,
  mostDamagedFloor,
  buckling,
  brace,
  pillarBeamJoint,
  pillarBase,
  corrosion
]

const RC = [
  partsDamageGte3,
  surrounding,
  groundDestructionSettlement,
  settlementSlope,
  mostDamagedFloor,
  pillarDamage5,
  pillarDamage4
]

const card = {
  [CONSTRUCTION_TYPE.WOOD]: WOOD,
  [CONSTRUCTION_TYPE.STEEL]: STEEL,
  [CONSTRUCTION_TYPE.RC]: RC
}

/**
 * 指定された建物構造タイプに対応するカードオブジェクトを返却する
 *
 * @param selectedConstructionType 選択された構造タイプ
 * @returns 該当するカードオブジェクト
 */
export const getNeighboringCards = (selectedConstructionType: ConstructionTypeType) => {
  const cards = card[selectedConstructionType]

  if (!cards) {
    console.error(`Invalid construction type: ${selectedConstructionType}`)
    return null
  }

  return cards
}
